import { ConfigProvider, Drawer } from 'antd';
import styled from 'styled-components';
import { Button, Colors, Row, Text } from 'basic-ui-lib';
import { RadioButtons } from 'basic-ui-lib/components/RadioButtons';
import { useState } from 'react';

interface PlaylistPickerModalProps {
  open?: boolean;
  value?: string;
  onChange?: (storeId: string) => void;
  playlistOptions?: { label: string; value: string }[];
  onClose?: () => void;
}

const PlaylistPickerModal = ({ value, onChange, playlistOptions, open, onClose }: PlaylistPickerModalProps) => {
  const [playlistId, setPlaylistId] = useState(value || '');

  const handleChoose = () => {
    onChange?.(playlistId);
    onClose?.();
  };

  return (
    <ConfigProvider>
      <StyledDrawer
        title={
          <Row flex={1} justifyContent='center' alignItems='center'>
            <Text title_h6 semibold center>
              Playlist
            </Text>
          </Row>
        }
        placement='bottom'
        closable={false}
        onClose={onClose}
        open={open}
        height='80%'
        footer={
          <Row>
            <Button type_cancel lg onClick={onClose} style={{ width: '100%' }}>
              Close
            </Button>
            <Button type_second lg style={{ width: '100%' }} onClick={handleChoose}>
              OK
            </Button>
          </Row>
        }
        destroyOnClose
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        <RadioButtons options={playlistOptions || []} value={playlistId} onChange={setPlaylistId} className='radio-styled' />
      </StyledDrawer>
    </ConfigProvider>
  );
};

PlaylistPickerModal.displayName = 'PlaylistPickerModal';
export default PlaylistPickerModal;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 16px 16px 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: ${Colors.neutral.bg[2]};
  }

  .ant-drawer-footer {
    padding: 16px 16px;
    box-shadow: 0px -4px 8px 0px #0000001a;
    background-color: ${Colors.neutral.bg[1]};
  }

  .radio-styled {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 24px;
  }
`;
